import React from 'react';
import Logo from '../../../images/Product/list-of-participants.png';

const ImagesListOfParticipants = () => <img alt="d-sinple List of participants" src={Logo} />;

export default ImagesListOfParticipants;
